import React, { createContext, forwardRef, useEffect, useImperativeHandle, useState } from 'react'
import { LoadPanel } from 'devextreme-react/load-panel'
import { t } from 'i18next'
import { UniqueTab } from './componenets/UniqueTab.jsx'

const InnerAppCtx = createContext({})

export const InnerAppProvider = forwardRef((props, ref) => {
  const [loading, setLoading] = useState(false)
  const value = { loading, setLoading }
  const [showLoadingIndicator, setShowLoadingIndicator] = useState(true)

  const [isFormDirty, setIsFormDirty] = useState(false)

  useEffect(() => {
    const handleNavigation = (event) => {
      const link = event.target.closest('a')

      if (!link || !link.hasAttribute('href') || link.hasAttribute('target')) {
        return
      }

      if (isFormDirty) {
        const userConfirmed = window.confirm(t('ui.unsaved_changes'))

        if (!userConfirmed) {
          event.preventDefault()
          event.stopPropagation()
        } else {
          setIsFormDirty(false)
        }
      }
    }

    const handleBeforeUnload = (event) => {
      if (isFormDirty) {
        event.preventDefault()
        event.stopPropagation()
        event.returnValue = t('ui.unsaved_changes')
        return true
      }
    }

    const handlePopState = (event) => {
      // back button in browser, popstate event is not cancellable
      if (isFormDirty) {
        setIsFormDirty(false)
      }
    }

    document.addEventListener('click', handleNavigation, true)
    window.addEventListener('beforeunload', handleBeforeUnload, { capture: true })
    window.addEventListener('popstate', handlePopState, { capture: true })

    return () => {
      document.removeEventListener('click', handleNavigation, true)
      window.removeEventListener('beforeunload', handleBeforeUnload, { capture: true })
      window.removeEventListener('popstate', handlePopState, { capture: true })
    }
  }, [isFormDirty])

  useImperativeHandle(ref, () => {
    return {
      setLoading: (val, showLoadingIndicator = true) => {
        setLoading(val)
        setShowLoadingIndicator(showLoadingIndicator)
      },
      setIsFormDirty
    }
  }, [])

  return (
    <InnerAppCtx.Provider value={value}>
      {value.loading && (
        <LoadPanel
          shadingColor='rgba(0,0,0,0.6)'
          visible
          showIndicator={showLoadingIndicator}
          shading
          showPane={showLoadingIndicator}
          wrapperAttr={{
            class: showLoadingIndicator ? 'load-panel-show-message' : ''
          }}
          message={t('messages.loading_please_wait')}
        />
      )}

      <UniqueTab />
    </InnerAppCtx.Provider>
  )
})
